var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mechanism-checklist"},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"lg"}}),(!_vm.loading)?_c('manage-checklist',{attrs:{"checklist":_vm.repeatChecklist,"isRepetitive":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }